import type React from 'react'
import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from '../../TextBlock'

import { TextBoxColors } from 'atoms/TextBox'
import { TextBoxFontSm, TextBoxFontSmBold } from 'atoms/TextBox/Templates'
import { Colors } from 'atoms/TextBox/TextBox.h'
import { TextBlock } from '../../TextBlock'

export interface ITextBlockDescriptionType4 extends ITextBlockProps {
  children?:
    | React.ReactElement<ITextBoxProps>
    | React.ReactElement<ITextBoxProps>[]
  title?: ITextBoxProps['title']
  description?: ITextBoxProps['title']
  colorDescription?: TextBoxColors
}

export const TextBlockDescriptionType4 = ({
  title,
  description,
  colorDescription = TextBoxColors.TEXT_ICON_PRIMARY,
  ...rest
}: ITextBlockDescriptionType4): JSX.Element => {
  return (
    <>
      {title && description && (
        <TextBlock {...rest}>
          <TextBoxFontSmBold
            maxLines={1}
            title={title}
            color={Colors.TEXT_ICON_SECONDARY}
          />
          <TextBoxFontSm color={colorDescription} preWrap>
            {description}
          </TextBoxFontSm>
        </TextBlock>
      )}
    </>
  )
}
